import styled from "@emotion/styled";

interface PropsText {
  label: string;
}

export const TagHeader = styled.nav<PropsText>`
  position: relative;
  border: 1px solid #383838;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  color: #383838;
  font-size: 1rem;
  min-width: 8rem;
  text-align: center;

  &::before {
    content: "${(props) => props.label}";
    position: absolute;
    top: -10px;
    left: 5px;
    background-color: #ffffff;
    padding: 0px 5px;
    font-size: 0.6rem;
  }
`;

export const GroupTag = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
  padding: 1rem 2rem;
`;
